import styled from 'styled-components';
import { IconWrapper } from '../ui';
import { PageContent, PageMainContainer } from './basic';

interface IStatusScreenCircleContainer {
	type: 'success' | 'warning' | 'error';
}

export const PageStatusScreenMain = styled(PageMainContainer)`
	height: 100%;
`;
export const PageStatusScreenContent = styled(PageContent)`
	height: inherit;
	width: 100%;
	align-items: center;
	justify-content: center;
	display: flex;
	flex-direction: column;
	text-align: center;
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
`;
export const StatusScreenCircleContainer = styled.div<IStatusScreenCircleContainer>`
	width: 64px;
	height: 64px;
	background-color: ${({ theme, type }) => {
		switch (type) {
			case 'success':
				return theme.color.emerald;
			case 'error':
				return theme.color.sunsetOrange;
			case 'warning':
				return theme.color.hokeyPokey;
			default:
				return theme.color.porcelain;
		}
	}};
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	margin-bottom: 24px;

	${IconWrapper} {
		width: 40px;
		color: ${({ theme }) => theme.color.white};
	}
`;
export const StatusScreenErrorCode = styled.span`
	font-size: 12px;
	margin-top: 16px;
	color: ${({ theme }) => theme.color.osloGrey};
`;
export const PageSuccessImgContainer = styled.div`
	margin-bottom: 24px;
	width: 64px;
	height: 64px;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 50%;
	overflow: hidden;
	img {
		width: 100%;
		height: auto;
	}
`;
